export default "/react/logoBotPot-5313e8d5.png";